import { createAsyncThunk } from '@reduxjs/toolkit';
import { uniq } from 'lodash';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { patchPermissionsOfUsers } from '../../services/patchPermissionsOfUsers';
import {
  selectUserBusinessPermissionModifications,
  selectUserProjectPermissionModifications,
} from '../selectors/permissionsSelectors';

export const updatePermissionsOfUsers = createAsyncThunk(
  'permissionsManagement/updatePermissionsOfUsers',
  async (_, { getState }) => {
    const selectedProjectId = selectSelectedProjectId(getState());
    const userProjectPermissionModifications =
      selectUserProjectPermissionModifications(getState());

    const userBusinessPermissionModifications =
      selectUserBusinessPermissionModifications(getState());

    const response = await patchPermissionsOfUsers(selectedProjectId, [
      ...Object.values(userProjectPermissionModifications),
      ...Object.values(userBusinessPermissionModifications),
    ]);

    return response;
  }
);

export const massUpdatePermissionsOfUsers = createAsyncThunk(
  'permissionsManagement/massUpdatePermissionsOfUsers',
  async (roleId, { getState }) => {
    const {
      permissions: { selectedUsersToUpdatePermissions },
    } = getState();

    const state = getState();

    const selectedProjectId = selectSelectedProjectId(state);

    const usersPermissions = selectedUsersToUpdatePermissions.map((user) => ({
      userId: user,
      roleId,
      projectId: selectedProjectId,
    }));

    const projectIds = uniq(usersPermissions.map((p) => p.projectId));

    const response = await patchPermissionsOfUsers(
      usersPermissions,
      projectIds
    );

    return response;
  }
);
